import moment from 'moment/moment';
import { formatReceived } from 'utils/formatValues';

/**
 * format a basic configuracion catalog
 * @returns {object[]}
 */
export const ConfiguracionFormatterById = (record) => {
  const dataFormatedById = {
    ...formatReceived(record),
    // Convierte la fecha de vigencia final a objeto moment si existe, si no null
    vigencia_final: record?.vigencia_final
      ? moment(record?.vigencia_final)
      : null,

    // Asigna el ID del estado global
    estados_globales: record?.estados_globales?.id, //  aquí sí es un ID
  };
  return dataFormatedById;
};
export const ConfiguracionFormattDate = (record) => {
  const _record = record;
  if (record.vigencia_final?.format) {
    _record.vigencia_final = record.vigencia_final.format('YYYY-MM-DD');
  }
  return _record;
};
